<template>
    <v-autocomplete :model-value="modelValue" :items="items" :loading="loading" item-title="name" item-value="id" :label="label" :multiple="multiple" variant="outlined" :error-messages="errorMessages" :no-data-text="noDataText" @update:model-value="$emit('update:modelValue', $event)">
        <template v-if="showPendingPayouts" #item="{ item, props: itemProps }">
            <v-list-item v-bind="itemProps">
                <template #subtitle>
                    <template v-if="item.raw.project_name">{{ item.raw.project_name }} — </template>{{ item.raw.pending_payout_count }} pending payout(s)
                </template>
            </v-list-item>
        </template>
    </v-autocomplete>
</template>

<script setup lang="ts">
import type { EligibleOwner } from '@app/purchase/bundle/routes/routes';

defineProps({
    modelValue: {
        type: [String, Array, null] as PropType<string | string[] | null>,
        default: null,
    },
    items: {
        type: Array as PropType<EligibleOwner[]>,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    showPendingPayouts: {
        type: Boolean,
        default: false,
    },
    errorMessages: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        default: 'Select a land owner',
    },
    noDataText: {
        type: String,
        default: 'No eligible owners found',
    },
});

defineEmits<{
    'update:modelValue': [value: string | string[] | null];
}>();
</script>
